"use client";
import { Error } from "@/components/Error";
import PageNotFound from "../../public/images/page_not_found.png";
import { useEffect, useState } from "react";
import { getClientSideCookieValue } from "@/utils/common.helpers";
import {
  CookiesEnum,
  cookiesValues,
  PageViewedEventPageNameEnum,
} from "@/constants/constants";
import { fallbackCopies } from "@/constants/fallbackCopies";

export const NotFound = () => {
  const [currentLanguage, setCurrentLanguage] = useState<string>();
  useEffect(() => {
    const currentLang = getClientSideCookieValue(
      cookiesValues[CookiesEnum.Lang],
    );
    setCurrentLanguage(currentLang);
  }, []);

  if (!currentLanguage) return null;

  const strings =
    fallbackCopies[currentLanguage as keyof typeof fallbackCopies];

  return (
    <Error
      buttonLabel={strings.not_found_screen.cta}
      buttonLink="/"
      description={strings.not_found_screen.description}
      imageAlt="Error Image"
      imageSrc={PageNotFound}
      mainText={strings.not_found_screen.heading}
      errorPageName={PageViewedEventPageNameEnum.notFoundPage}
    />
  );
};

export default NotFound;
